/**
 * Make the list function like a <select> element
 */
document.addEventListener('DOMContentLoaded', function() {
    let pageLinksRoot = document.querySelectorAll('.dropdown-selector');
    if(!pageLinksRoot) return;

    pageLinksRoot.forEach((dropdown) => {
        let pageLinksClickTarget = dropdown.querySelector('.dropdown-heading');
        let pageLinksClickArrow = dropdown.querySelector('.dropdown-arrow');

        pageLinksClickTarget.addEventListener('click', function() {
            let targetList = dropdown.querySelector('.dropdown-sim');
            let currentHeight = targetList.offsetHeight;
            let targetHeight = targetList.scrollHeight;

            pageLinksClickArrow.classList.toggle('clicked');

            if(currentHeight == 0) {
                targetList.style.height = targetHeight + 'px';
                dropdown.classList.toggle('active');
            } else {
                targetList.style.height = '0px';
                setTimeout(function() {
                    dropdown.classList.toggle('active');
                }, 300);
            }
        });
    })
});